import magnifiAPIInstance from "./apiInstance";

export const videoConversionTemplateAPIs = {
  getVideoConversionTemplatesByEntityId: ({ payload }) =>
    magnifiAPIInstance.post("/api/v3/video-conversion/templates", payload),
  createVideoConversionTemplate: ({ payload }) =>
    magnifiAPIInstance.post("/api/v3/video-conversion/template/create", payload),
  editVideoConversionTemplate: ({ payload }) =>
    magnifiAPIInstance.post("/api/v3/video-conversion/template/edit", payload),
  deleteVideoConversionTemplate: ({ payload }) =>
    magnifiAPIInstance.delete(`/api/v3/video-conversion/template/${payload.templateId}`),
};
